import {BaseRepository} from "../../../infrastructure/repositories/base-repository";
import {DomUtils} from "../../../infrastructure/utils/dom-utils";
import {LoggerUtils} from "../../../infrastructure/utils/logger/logger-utils";
import {SiteConfig} from "../../../core/bootstrap/models/site-config";
import {DeviceStore} from "../../../core/app/device.store";
import {EntitiesRecognizerApi} from "./entities-recognizer.api";
import {EntitiesRecognizerFactory} from "./entities-recognizer.factory";

export class EntitiesRecognizerRepository extends BaseRepository {
  static injectables = [DomUtils, LoggerUtils, SiteConfig, DeviceStore, EntitiesRecognizerApi, EntitiesRecognizerFactory];
}
